<template>
  <div class="b-menu-pagination-actions" :class="classes">
    <div class="b-menu-pagination-actions__container">

      <div class="b-menu-pagination-actions__prev">
        <div v-if="hasPrevious" class="b-menu-pagination-actions__button-container" :style="[buttonSize]"
             @dragenter="dragenterPrevious" @dragleave="dragleave" @click="previous">
          <slot name="previous"></slot>
        </div>
      </div>

      <div class="b-menu-pagination-actions__next">
        <div v-if="hasNext" class="b-menu-pagination-actions__button-container" :style="[buttonSize]"
             @dragenter="dragenterNext" @dragleave="dragleave" @click="next">
          <slot name="next"></slot>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import DomHelper from '../util/DomHelper'
import StoreHelper from '../store/helper'

import _ from 'lodash'

const PAGINATION_BUTTON_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
  AROUND: 'around'
}

const TIMEOUT_BEFORE_PAGE_SWITCH_ON_DRAGOVER = 1500

export default {
  name: 'b-menu-pagination-actions',
  props: {
    hasPrevious: {
      type: Boolean,
      default: true
    },
    hasNext: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: PAGINATION_BUTTON_POSITIONS.BOTTOM,
      validator: v => _.toArray(PAGINATION_BUTTON_POSITIONS).includes(v)
    }
  },
  data () {
    return {
      isActiveByDrag: false
    }
  },
  methods: {
    previous () { this.$emit('click:previous') },
    next () { this.$emit('click:next') },
    dragenterPrevious (e) {
      if (this.isActiveByDrag || !this.hasPrevious) return

      e.preventDefault()
      this.isActiveByDrag = true
      this.playPulseAnimation(e.target)
      this.startCountdown(this.previous)
    },
    dragenterNext (e) {
      if (this.isActiveByDrag || !this.hasNext) return

      e.preventDefault()
      this.isActiveByDrag = true
      this.playPulseAnimation(e.target)
      this.startCountdown(this.next)
    },

    dragleave (e) {
      e.preventDefault()
      this.isActiveByDrag = false
    },
    playPulseAnimation (el) {
      setTimeout(() => {
        DomHelper.playPulseScaleAnimation(el)
      }, TIMEOUT_BEFORE_PAGE_SWITCH_ON_DRAGOVER / 2)
    } ,
    startCountdown (action) {
      setTimeout(() => {
        if (this.isActiveByDrag) {
          this.isActiveByDrag = false
          action()
        }
      }, TIMEOUT_BEFORE_PAGE_SWITCH_ON_DRAGOVER)
    }
  },
  computed: {
    classes () {
      return {
        'b-menu-pagination-actions--top': _.isEqual(this.position, PAGINATION_BUTTON_POSITIONS.TOP),
        'b-menu-pagination-actions--bottom': _.isEqual(this.position, PAGINATION_BUTTON_POSITIONS.BOTTOM),
        'b-menu-pagination-actions--around': _.isEqual(this.position, PAGINATION_BUTTON_POSITIONS.AROUND)
      }
    },
    buttonSize () {
      return { width: `${StoreHelper.getPaginationButtonSize()}px`, height: `${StoreHelper.getPaginationButtonSize()}px` }
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-pagination-actions {
  $root: &;
  height: 130%;
  width: 130%;
  margin: -15%;
  display: flex;

  &__prev {
    display: flex;
    flex: 1;
    margin-right: 10px;
    flex-direction: row-reverse;
  }

  &__next {
    display: flex;
    flex: 1;
    margin-left: 10px;
  }

  &__button-container {
    cursor: pointer;
    pointer-events: all;

    > * {
      pointer-events: none;
    }
  }

  &__container {
    height: fit-content;
    display: flex;
    width: 100%;
  }

  &--top {
    align-items: flex-start;
  }

  &--around {
    align-items: center;

    #{$root}__prev,
    #{$root}__next {
      justify-content: flex-end;
    }
  }

  &--bottom {
    align-items: flex-end;
  }
}
</style>
